import { render } from "./sqmCombinationConfig.vue?vue&type=template&id=545e0f9f&ts=true"
import script from "./sqmCombinationConfig.vue?vue&type=script&lang=ts"
export * from "./sqmCombinationConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__